import { combineReducers } from 'redux'
import page from './simple-editor';

const simplePages = combineReducers({
  page
});

export default simplePages;
